import StorageObject from 'ember-local-storage/local/object';

export default class ProtectFlowStateStorage extends StorageObject {
  initialState() {
    return {};
  }
}
